import { render, staticRenderFns } from "./stepfour.vue?vue&type=template&id=fed8d100&scoped=true&"
import script from "./stepfour.vue?vue&type=script&lang=js&"
export * from "./stepfour.vue?vue&type=script&lang=js&"
import style0 from "./stepfour.vue?vue&type=style&index=0&id=fed8d100&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fed8d100",
  null
  
)

export default component.exports